/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

/**
 * Arguments for migrate instruction.
 * These are deserialized from the migrator_migrate_payload passed by initializer.
 */
export type MigrateArgs = {
  /** Base tokens reserved for distribution to recipients */
  baseForDistribution: bigint;
  /** Base tokens reserved for CPMM liquidity */
  baseForLiquidity: bigint;
};

export type MigrateArgsArgs = {
  /** Base tokens reserved for distribution to recipients */
  baseForDistribution: number | bigint;
  /** Base tokens reserved for CPMM liquidity */
  baseForLiquidity: number | bigint;
};

export function getMigrateArgsEncoder(): FixedSizeEncoder<MigrateArgsArgs> {
  return getStructEncoder([
    ['baseForDistribution', getU64Encoder()],
    ['baseForLiquidity', getU64Encoder()],
  ]);
}

export function getMigrateArgsDecoder(): FixedSizeDecoder<MigrateArgs> {
  return getStructDecoder([
    ['baseForDistribution', getU64Decoder()],
    ['baseForLiquidity', getU64Decoder()],
  ]);
}

export function getMigrateArgsCodec(): FixedSizeCodec<
  MigrateArgsArgs,
  MigrateArgs
> {
  return combineCodec(getMigrateArgsEncoder(), getMigrateArgsDecoder());
}
